import { useState } from 'react';

const Nav = ({data, setData, activeCode, setActiveCode, activeCommand, setCommand, setActiveCommand}) => {
    const [newCode, setNewCode] = useState(null);
    const [newCodeValue, setNewCodeValue] = useState('');
    const [error, setError] = useState(false);
    const [newCommand, setNewCommand] = useState(null);
    const [newCommandValue, setNewCommandValue] = useState('');
    const [errorCommand, setErrorCommand] = useState(false);

    const saveNewCode = () => {
        setError(false);
        if (!newCodeValue.length)
            close();
        else {
            if (!data.commands[newCodeValue.toUpperCase()]) {
                setData({
                    type: 'newCode',
                    value: newCodeValue.toUpperCase()
                });
                setNewCode(false);
                setNewCodeValue('');
            } else
                setError('Code already exists');
        }
    }

    const saveNewCommand = (key) => {
        console.log(data.commands[key][newCommandValue])
        setErrorCommand(false);
        if (!newCommandValue.length)
            closeCommand();
        else {
            if (!data.commands[key][newCommandValue]) {
                setData({
                    type: 'newCommand',
                    key,
                    value: newCommandValue
                });
                setNewCommand(false);
                setNewCommandValue('');
            } else
                setErrorCommand('Command already exists');
        }
    }

    const close = () => {
        setNewCode(false);
        setNewCodeValue('');
        setError(false);
    }

    const closeCommand = () => {
        setNewCommand(false);
        setNewCommandValue('');
        setErrorCommand(false);
    }

    return (
        <aside>
            <button type="button" onClick={() => {
                setActiveCode(null);
                setActiveCommand(null);
            }}>General info</button>
            <h4>Commands</h4>
            <ul>
                {data.commands &&
                    <>
                        {Object.keys(data.commands).map((commandCode) => (
                            <li key={commandCode} className={activeCode === commandCode ? 'active' : ''}>
                                <span onClick={() => {
                                    setActiveCode(commandCode);
                                    setActiveCommand(null);
                                }}>{commandCode}</span>
                                <ul>
                                    {data.commands[commandCode] &&
                                        <>{Object.keys(data.commands[commandCode]).map((commandKey) => (
                                            <li key={commandCode + commandKey} 
                                                onClick={() => setCommand(commandKey)} 
                                                className={activeCommand === commandKey ? 'active' : ''}>
                                                {commandKey}
                                            </li>
                                        ))}</>
                                    }
                                    <li>
                                        {newCommand ? <div className="new-form">
                                            <h3>New command</h3>
                                            <input name="new-command" value={newCommandValue}    onChange={(e) => setNewCommandValue(e.target.value)} />
                                            <span onClick={() => saveNewCommand(commandCode)}>&#10004;</span>
                                            <span onClick={closeCommand}>&#x2715;</span>
                                            {errorCommand && <p className="error">{errorCommand}</p>}
                                        </div> : <button type="button" onClick={() => setNewCommand(true)}>Add command</button>}
                                    </li>
                                </ul>
                            </li>
                        ))}
                    </>
                }
                <li>
                    {newCode ? <div className="new-form">
                        <h3>New code</h3>
                        <input name="new-code" value={newCodeValue} maxLength={1} onChange={(e) => setNewCodeValue(e.target.value)} />
                        <span onClick={saveNewCode}>&#10004;</span>
                        <span onClick={close}>&#x2715;</span>
                        {error && <p className="error">{error}</p>}
                    </div> : <button type="button" onClick={() => setNewCode(true)}>Add code</button>}
                </li>
            </ul>
        </aside>
    )
};

export default Nav;